/* unplugin-vue-components disabled */import script from "./EditCustomerManage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCustomerManage.vue?vue&type=script&setup=true&lang=js"

import "./EditCustomerManage.vue?vue&type=style&index=0&id=3b17801f&lang=scss"

const __exports__ = script;

export default __exports__